/**
 * Fill `{key}` placeholders. `{{key}}` (the i18next spelling a few strings use) is
 * accepted too — the single-brace pass alone left the outer braces on screen
 * ("{Shawarma} is outside its availability window"). Unknown keys stay as written.
 *
 * ⛔ Lives here, NOT in `contexts/LanguageContext` ('use client'): a server
 *    component that called it through the context module crashed the whole
 *    reservation calendar ("Attempted to call interpolate() from the server",
 *    e2e B-27). Server and client code both import this file.
 */
export function interpolate(str: string, params: Record<string, string | number>): string {
  return str.replace(/\{\{(\w+)\}\}|\{(\w+)\}/g, (match, k2: string | undefined, k1: string | undefined) => {
    const key = (k2 ?? k1) as string
    return key in params ? String(params[key]) : match
  })
}
